import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { RadarDataPoint } from '@/sections/customerManagement/types';
import {
  getImprovementTip,
  getMetricColorClassByLabel,
} from '@/sections/customerManagement/utils/leaderboardTransforms';

interface Props {
  radarData: RadarDataPoint[];
}

export function ImprovementAccordion({ radarData }: Props) {
  const improvementMetrics = radarData.filter(d => d.value < 50);

  if (improvementMetrics.length === 0) return null;

  return (
    <Card>
      <Accordion type="single" collapsible defaultValue="improvements">
        <AccordionItem value="improvements" className="border-none">
          <CardHeader className="p-0">
            <AccordionTrigger className="px-6 py-4 hover:no-underline">
              <CardTitle className="text-sm font-medium">
                Improvements
              </CardTitle>
            </AccordionTrigger>
          </CardHeader>
          <AccordionContent>
            <CardContent className="pt-0">
              <p className="text-chariot-text-secondary mb-4 text-xs">
                Metrics below the 50th percentile. Focus on these to climb the
                leaderboard.
              </p>
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                {improvementMetrics.map(d => {
                  const pillClasses =
                    d.value <= 25
                      ? 'bg-chariot-stroke-red/20 text-chariot-stroke-red'
                      : 'bg-chariot-stroke-high/20 text-chariot-stroke-high';

                  return (
                    <Card key={d.metric} className="bg-chariot-layer1">
                      <CardContent className="p-4">
                        <div className="mb-2 flex items-center gap-2">
                          <span
                            className={`text-sm font-semibold ${getMetricColorClassByLabel(d.metric)}`}
                          >
                            {d.metric}
                          </span>
                          <span
                            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${pillClasses}`}
                          >
                            {d.value}th percentile
                          </span>
                        </div>
                        <p className="text-chariot-text-secondary text-xs leading-relaxed">
                          {getImprovementTip(d.metric)}
                        </p>
                      </CardContent>
                    </Card>
                  );
                })}
              </div>
            </CardContent>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </Card>
  );
}
